import Folder from "./Folder";
import styles from "./Folders.module.css";

const Folders = ({ setOpenFolderName, clicked, setClicked }) => {
  const folders = [
    { id: 1, title: "Background" },
    { id: 2, title: "1337" },
    { id: 3, title: "IM Creation" },
    { id: 4, title: "Ark-x" },
  ];
  return (
    <div className={styles.folders}>
      {folders.map((folder) => (
        <Folder
          key={folder.id}
          title={folder.title}
          setOpenFolderName={setOpenFolderName}
          clicked={clicked}
          setClicked={setClicked}
        />
      ))}
    </div>
  );
};

export default Folders;
